import { render } from "./VvCouponCard.vue?vue&type=template&id=74b2acae&scoped=true"
import script from "./VvCouponCard.vue?vue&type=script&lang=js"
export * from "./VvCouponCard.vue?vue&type=script&lang=js"

import "./VvCouponCard.vue?vue&type=style&index=0&id=74b2acae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b2acae"]])

export default __exports__